import {
  NestedMappingParentSyncPair,
  pruneFieldMappingsHiddenByMappingParentOff,
} from './nestedMappingParentPersistence'
import {SettingControlSyncPairInput} from './useSettingControlHiddenStateSync'

export const buildNestedMappingParentSyncPairs = (
  inputs: SettingControlSyncPairInput[]
): NestedMappingParentSyncPair[] => {
  const pairs: NestedMappingParentSyncPair[] = []
  inputs.forEach(({thisSetting, oppositeSetting}) => {
    if (!thisSetting?.mappings_data?.length) {
      return
    }
    pairs.push({
      thisSideMappings: thisSetting.mappings_data,
      oppositeSideMappings: oppositeSetting?.mappings_data ?? [],
    })
  })
  return pairs
}

export const runNestedMappingParentHiddenStateSync = (params: {
  fieldMappings: any[]
  syncPairs: SettingControlSyncPairInput[]
  resolveMappingValue: (settingMappingId: number) => unknown
}): {fieldMappings: any[]; mappingsChanged: boolean} => {
  const mappingPairs = buildNestedMappingParentSyncPairs(params.syncPairs)
  const prunedMappings = pruneFieldMappingsHiddenByMappingParentOff(
    params.fieldMappings,
    mappingPairs,
    params.resolveMappingValue
  )

  return {
    fieldMappings: prunedMappings,
    mappingsChanged: prunedMappings !== params.fieldMappings,
  }
}
